import { Flex } from 'components/styled';

import styled from 'theme/styled';

export const SHARED_RESPONSIVE_PADDING_X = [2, 3, 4, 5];

export const Wrapper = styled(Flex)`
	flex: 1;
	flex-direction: column;
`;

export const ResponsivePadder = styled(Flex)`
	position: relative;
	flex-direction: column;
	width: 100%;
	margin-left: auto;
	margin-right: auto;
	max-width: 88em;
`;
ResponsivePadder.defaultProps = {
	px: SHARED_RESPONSIVE_PADDING_X,
};

export const ResponsiveWrapper = styled(ResponsivePadder)`
	flex: 1;
	position: relative;
	padding-bottom: ${p => p.theme.space[4]}px;
`;
